<template>
  <div class="z-editor">
    <!-- TinyMCE: ادیتور بصری HTML-native با جدول توکار و RTL.
         ویرایش مستقیم HTML از طریق دکمه‌ی «سورس» (پلاگین code) در تولبار. -->
    <editor
      v-model="val"
      :init="editorInit"
      tinymce-script-src="/tinymce/tinymce.min.js"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  // نام تاریخی حفظ شده تا مصرف‌کننده‌ها (<z-quill-editor>) بدون تغییر کار کنند.
  name: 'ZQuillEditor',
  components: {
    editor: Editor,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
  },
  data() {
    return {
      // محتوای ورودی را از فرمت قدیمی Quill پاک می‌کنیم تا لیست‌ها استاندارد شوند.
      val: this.cleanLegacy(this.value),
    }
  },
  computed: {
    editorInit() {
      return {
        base_url: '/tinymce',
        suffix: '.min',
        menubar: false,
        branding: false,
        promotion: false,
        directionality: 'rtl',
        height: 480,
        convert_urls: false, // آدرس تصویر/لینک را دست‌کاری نکن (آپلودها relative هستند)
        paste_data_images: true, // پیست تصویر → base64
        automatic_uploads: false,
        image_advtab: true,
        plugins:
          'lists advlist link image media table code codesample directionality '
          + 'autolink charmap searchreplace wordcount visualblocks fullscreen '
          + 'preview anchor emoticons',
        // wrap = همه‌ی دکمه‌ها در چند ردیف دیده شوند (به‌جای قایم‌شدن زیر «...»)
        toolbar_mode: 'wrap',
        toolbar:
          'undo redo | blocks fontfamily fontsize | bold italic underline strike | '
          + 'forecolor backcolor | alignright aligncenter alignleft alignjustify | '
          + 'bullist numlist outdent indent | link image media table anchor charmap emoticons | '
          + 'codesample subscript superscript | rtl ltr | '
          + 'searchreplace visualblocks removeformat | code preview fullscreen',
        block_formats:
          'پاراگراف=p; تیتر ۱=h1; تیتر ۲=h2; تیتر ۳=h3; تیتر ۴=h4; '
          + 'تیتر ۵=h5; تیتر ۶=h6; نقل‌قول=blockquote; کد=pre',
        fontsize_formats: '12px 14px 16px 18px 20px 24px 32px 48px',
        font_family_formats:
          'ایران‌سنس=IRANSans,Tahoma,sans-serif; تاهوما=Tahoma,sans-serif; '
          + 'Arial=arial,sans-serif; Times=times new roman,serif; Courier=courier new,monospace',
        content_style:
          'body{font-family:IRANSans,Tahoma,sans-serif;direction:rtl;font-size:14px;line-height:2}'
          + 'img{max-width:100%;height:auto}'
          + 'table{border-collapse:collapse}table td,table th{border:1px solid #ccc;padding:6px}',
        // آپلود تصویر مثل قبل: تبدیل به base64 و درج مستقیم (بدون سرور).
        file_picker_types: 'image',
        file_picker_callback(cb) {
          const input = document.createElement('input')
          input.setAttribute('type', 'file')
          input.setAttribute('accept', 'image/png, image/jpeg, image/gif, image/webp')
          input.onchange = () => {
            const file = input.files[0]
            if (!file) return
            const reader = new FileReader()
            reader.onload = () => cb(reader.result, { alt: file.name })
            reader.readAsDataURL(file)
          }
          input.click()
        },
      }
    },
  },
  watch: {
    value(v) {
      const cleaned = this.cleanLegacy(v)
      if (cleaned !== this.val) this.val = cleaned
    },
    val(v) {
      this.$emit('input', v)
    },
  },
  methods: {
    // پاکسازی محتوای تولیدشده با Quill 2.0-dev:
    //  - حذف span.ql-ui (نشانگر UI که نباید ذخیره شود)
    //  - تبدیل لیست بولت Quill (ol>li[data-list=bullet]) به <ul> استاندارد
    //  - حذف کلاس‌های ql-* و اتریبیوت data-list
    // idempotent است: روی HTML تمیز بی‌اثر می‌ماند.
    cleanLegacy(html) {
      if (typeof html !== 'string') return html
      if (html.indexOf('ql-ui') === -1 && html.indexOf('data-list') === -1) return html
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html')

        doc.querySelectorAll('span.ql-ui').forEach(s => s.remove())

        doc.querySelectorAll('ol').forEach(ol => {
          const items = Array.from(ol.children).filter(c => c.tagName === 'LI')
          const allBullet = items.length > 0
            && items.every(li => li.getAttribute('data-list') === 'bullet')
          if (allBullet) {
            const ul = doc.createElement('ul')
            while (ol.firstChild) ul.appendChild(ol.firstChild)
            ol.replaceWith(ul)
          }
        })

        doc.querySelectorAll('li[data-list]').forEach(li => li.removeAttribute('data-list'))

        doc.querySelectorAll('[class]').forEach(el => {
          const kept = el.className
            .split(/\s+/)
            .filter(c => c && !c.startsWith('ql-'))
            .join(' ')
          if (kept) el.setAttribute('class', kept)
          else el.removeAttribute('class')
        })

        return doc.body.innerHTML
      } catch (e) {
        return html
      }
    },
  },
}
</script>
